import React from "react";
import { Check, Copy } from "lucide-react";
import { copyToClipboard, shortAddr } from "@/lib/format";

export function AddressDisplay({ value, short = true, className = "", lead = 6, tail = 4 }) {
  const [copied, setCopied] = React.useState(false);
  if (!value) return <span className="font-mono text-slate-400">—</span>;
  const display = short ? shortAddr(value, lead, tail) : value;
  return (
    <span className={`inline-flex items-center gap-2 font-mono text-sm tracking-tight text-slate-900 ${className}`}>
      <span className="select-all">{display}</span>
      <button
        type="button"
        aria-label="copy address"
        onClick={async () => {
          await copyToClipboard(value);
          setCopied(true);
          setTimeout(() => setCopied(false), 1200);
        }}
        className="text-slate-400 hover:text-slate-900 transition-colors"
      >
        {copied ? <Check className="w-3.5 h-3.5" strokeWidth={1.75} /> : <Copy className="w-3.5 h-3.5" strokeWidth={1.5} />}
      </button>
    </span>
  );
}
